export default "__VITE_ASSET__wSV4ge8E__";